import classNames from 'classnames';
import React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

export const Dropdown = ({ value, options, label, onClick, width, className }) => {
    return (
        <div className={classNames("dropdown-box-container", className)} style={{ minWidth: width }}>
            <span className="dropdown-label-container">
                {label}
            </span>
            <UncontrolledDropdown>
                <DropdownToggle
                    caret={true}
                    tag="div"
                    type="button"
                    className="dropdown-toggle-container"
                >
                    <div>
                        {value?.label} {' '}
                        {value?.rightIcon}
                        {value?.subLabel != null && (
                            <span className="dropdown-toggle-sublabel"> · {value.subLabel}</span>
                        )}
                    </div>
                </DropdownToggle>
                <DropdownMenu>
                    {options.map((option, idx) => (
                        <DropdownItem
                            key={`${idx}-${option?.label ?? idx}`}
                            active={option===value}
                            type="button"
                            onClick={() => onClick(option)}
                            className="dropdown-item-container"
                        >
                            <span>{option.label} {' '}{option.rightIcon}</span>
                            {option.subLabel != null && (
                                <span className="dropdown-item-sublabel">{option.subLabel}</span>
                            )}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </UncontrolledDropdown>
        </div>
    );
}
